import { getEnvironmentIndicator } from "@/lib/environment";

type EnvironmentIndicatorProps = {
  hostname?: string;
  compact?: boolean;
};

export default function EnvironmentIndicator({
  hostname,
  compact = false,
}: EnvironmentIndicatorProps) {
  const resolvedHostname =
    hostname ??
    (typeof window !== "undefined" ? window.location.hostname : "localhost");

  const indicator = getEnvironmentIndicator(resolvedHostname);

  return (
    <div
      className={[
        "rounded-xl border px-3 py-2",
        indicator.tone,
        compact ? "text-xs" : "text-sm",
      ].join(" ")}
      aria-label={`${indicator.label} ${indicator.host}`}
    >
      <div className="flex items-center justify-between gap-3">
        <span className="font-semibold tracking-wide">{indicator.label}</span>
        <span className="rounded-full bg-black/5 px-2 py-0.5 font-medium uppercase tracking-wide">
          {indicator.stage}
        </span>
      </div>
      <p className="mt-1 truncate text-[11px] opacity-80 sm:text-xs">
        Host: {indicator.host}
      </p>
    </div>
  );
}
